import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { LiaShoppingBagSolid } from "react-icons/lia";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import Header from "../components/Header";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ItemsDetail = () => {

  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const { id } = useParams();
  const [selected_category, setSelectedCategory] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [pagination, setPagination] = useState(null);

  let initialSlide=0;
  if(selected_category){
    initialSlide = categories.findIndex(category => category._id === selected_category?._id);
  }

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 6, // Default (desktop)
    slidesToScroll: 1,
    initialSlide:initialSlide ,
    autoplay: false,
    touchThreshold: 10,
    swipeToSlide: true,
    draggable: true,
    touchMove: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // If screen < 1024px, apply these settings
        settings: {
          slidesToShow: 6 // Optional: You might not need this if it matches the default
        }
      },
      {
        breakpoint: 768, // If screen < 768px, apply these settings
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 480, // If screen < 480px, apply these settings
        settings: {
          slidesToShow: 3
        }
      }
    ]
  };


  
  const getAllCategories = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getAllCategories",
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        setCategories(data.data);
        if (id) {
          const category= data.data.find(category => category._id === id);
          setSelectedCategory(category);
        }else{
          await getMenuItems();
        }

      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
      toast.error("Failed to load dashboard");
    } finally {
      setIsLoader(false);
    }
  };

  const getMenuItems = async (categoryId = null, loadMore = false) => {
    try {
      if (loadMore) {
        setLoadingMore(true);
      } else {
        setIsLoader(true);
        setPage(1);
        setItems([]);
        setHasMore(true);
      }

      const currentPage = loadMore ? page + 1 : 1;
      
      const response = await ApiService.request({
        method: "GET",
        url: "/getMenuItems",
        data: {
          category_id: categoryId || selected_category?._id || null,
          page: currentPage,
          limit: 20
        },
      });
      const data = response.data;

      console.log(data);
      if (data.status) {
        const newItems = data.data.items;
        const paginationData = data.data.pagination;
        
        if (loadMore) {
          setItems(prevItems => [...prevItems, ...newItems]);
          setPage(currentPage);
        } else {
          setItems(newItems);
          setPage(1);
        }
        
        setPagination(paginationData);
        setHasMore(paginationData.current_page < paginationData.total_pages);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Dashboard loading error:", error);
      toast.error("Failed to load items");
    } finally {
      setIsLoader(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = () => {
    if (!loadingMore && hasMore && pagination && pagination.current_page < pagination.total_pages) {
      getMenuItems(null, true);
    }
  };

   
   useEffect(() => {
     window.scrollTo(0, 0);
     getAllCategories();

   }, []);

  useEffect(() => {
    if (selected_category) {
      getMenuItems(selected_category._id, false);
    }
   }, [selected_category]);

  return (
    <>
    {isLoader ?(
        <PageLoader />
    ):(

      <div className="main-heading container items-details-main">
        
        <Header title={selected_category?.title ?? 'Menu Items'} />

        <div className="slider-container mb-4">
          <Slider {...settings}>
            {categories.map((category, index) => (
              <div
                key={index}
                className={`slide-1 shadow ${category._id === selected_category?._id ? "active" : ""}`}
                onClick={() => setSelectedCategory(category)}
              >
                <div className="info">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="slide-1-image"
                  />
                  <span className="d-none d-md-inline">{category.title}</span>
                  <span className="d-inline d-md-none">{category.title.substring(0, 9)}</span>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Items */}
        <div className="row px-3">
          {items.length > 0 ? (
            items.map((item) => (
              <Link to={'/item/'+item._id} className="col-12 col-md-4 " key={item._id}>
                <div className="border rounded bg-white mb-3 p-3">
                  <div className="row align-items-center">
                    <div className="col-8 deal-data">
                      <h6>{item.title}</h6>
                      <p className="text-muted item-des">{item.description}</p>
                      <div className="d-flex below-section">
                        <h6>AED {(item?.discounted_price)?item?.discounted_price:item?.original_price} </h6>
                        {/* <Link to={'/item/'+item._id}>
                          <button className="btn btn-sm btn-success text-white mx-3">
                            Order
                          </button>
                        </Link> */}
                      </div>
                    </div>
                    <div className="col-4 text-end">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="  item-img item-img-1"
                      />
                    </div>
                    
                  </div>
                </div>
              </Link>
            ))
          ) : (
            !isLoader && (
              <div className="col-12 text-center py-5">
                <div className="text-muted">
                  <h5>No items found</h5>
                  <p>Try selecting a different category</p>
                </div>
              </div>
            )
          )}
        </div>

        {/* Load More Button */}
        {hasMore && (
          <div className="text-center mt-4 mb-4">
            <button
              className="btn btn-base px-4 py-2"
              onClick={handleLoadMore}
              disabled={loadingMore}
            >
              {loadingMore ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Loading...
                </>
              ) : (
                'Load More'
              )}
            </button>
          </div>
        )}

        {/* Show total items count */}
        {pagination && (
          <div className="text-center text-muted mb-3">
            Showing {items.length} of {pagination.total_records} items
            
          </div>
        )}

      </div>

    )}
      
    </>
  );
};

export default ItemsDetail;
